import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import ListFilters from 'components/sales/ListFilters/ListFilters';

const ScheduledMeetings = ({
  meetingList = null,
  getMeetingLists = null,
  match,
  getSiteFilters = null,
  siteFilters = null
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);

  const Headers = [
    'Site Number',
    'Business',
    'Meeting Agenda',
    'Scheduled Date',
    'BA Name',
    'Meeting Send',
    'Actions',
  ];

  useEffect(() => {
    if (getMeetingLists !== null)
      (async () => {
        setIsLoading(true);
        await getMeetingLists(match.params.id);
        setIsLoading(false);
      })();
  }, [getMeetingLists]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getSiteFilters();
      setIsLoading(false);
    })();
  }, [getSiteFilters]);

  useEffect(() => {
    const tableData = [
      'id',
      'site_no',
      'client_name',
      'subject',
      'scheduled_date',
      'name',
      'meeting_id'
    ];
    if (meetingList && meetingList.resultSets) {
    const data = meetingList.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => (
              key === 'meeting_id' ? (element[key] !== null ? {['Meeting Send']: 'Yes'} : {['Meeting Send']: 'No'}) :
              key === 'client_name' ? (element[key] == null ? {['Business']: 'Others'} : {['Business']: element['client_name']}) :
              { [key]: element[key] })),
          {
            Action:
              
              [
                {
                  name: 'View Details',
                  link: `${baseUrl}/brand-activation/scheduled-meeting-detail`,
                },
                {
                  name: 'Create MOM',
                  link: `${baseUrl}/brand-activation/create-mom/${element?.site_id}`,
                },
                {
                  name: 'View MOM',
                  link: `${baseUrl}/brand-activation/view-mom`,
                },
              ]
          }
        )
      );
      console.log(data);
      if(data){
        setListData(data);
      }else{
        setListData([]);   
      }
    
   
    setPageCount(Math.ceil(meetingList.total / meetingList.per_page));
  }
  }, [meetingList]);

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getMeetingLists(filter, val.selected + 1);
    setIsLoading(false);
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    console.log(filterData);
    await getMeetingLists(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <div className="d-flex flex-row flex-wrap gap-2">
        <Link
          to={`${baseUrl}/brand-activation/view-cheque-picked`}
          className="btn btn-primary d-flex align-items-center justify-content-center gap-2 w-md-auto"
          style={{ flex: '0 0 auto' }}
        >
          {localization.chequePickedView}
          <img src={Images?.ArrowRight} alt="" className="img-fluid" style={{ height: '16px' }} />
        </Link>
        {meetingList?.statusCheck === 1 &&  meetingList?.draft_id && (
          <Link
          to={`${baseUrl}/brand-activation/edit-schedule-meeting/${meetingList?.draft_id}`}
          className="btn btn-primary d-flex align-items-center justify-content-center gap-2 w-md-auto"
          style={{ flex: '0 0 auto' }}
        >
          {localization.completeMeeting}
          <img src={Images?.ArrowRight} alt="" className="img-fluid" style={{ height: '16px' }} />
        </Link>
        )}
        { (meetingList?.statusCheck !== 1 ) && (
          <>
        <Link
        to={`${baseUrl}/brand-activation/check-in-meeting`}
        className="btn btn-primary d-flex align-items-center justify-content-center gap-2 w-md-auto"
        style={{ flex: '0 0 auto' }}
        >
        {localization.checkIn}
        <img src={Images?.ArrowRight} alt="" className="img-fluid" style={{ height: '16px' }} />
        </Link>
      </>
       )} 
        {/* {meetingList?.statusCheck === 4 && (
            <Link
            to={`${baseUrl}/brand-activation/schedule-new-meeting/${meetingList?.statusCheck}`}
            className="btn btn-primary d-md-inline-block"
          >
            {localization.completeMeeting}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        )} */}
        <Button
        onClick={filterToggle}
        className="btn btn-transparent d-flex align-items-center justify-content-center gap-2 w-md-auto"
        style={{ flex: '0 0 auto' }}
      >
        <img src={Images.Filter} alt="" className="img-fluid" style={{ height: '16px' }} />
        {localization.showFilters}
      </Button>
      </div>
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.meetingHistory}
      Buttons={headerBtns}
      // isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/sites-listing`}
    >
      {/* <TableSection
        data={listData}
        headers={Headers}
        detailList={meetingList}
        isId={false}
      /> */}
       <TableSection
        data={listData}
        isId={false}
        headers={Headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
        srNo={meetingList?.from}
        // detailList={meetingList}
      />
       <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'1,2,3'}
        listFilterData={siteFilters ? siteFilters : null}
        meetingFilter
      />
    </Layout>
  );
};

ScheduledMeetings.propTypes = {
  meetingList: PropTypes.any,
  getMeetingLists: PropTypes.func,
  match: PropTypes.any,
};

export default ScheduledMeetings;
